import React, { useState } from "react";
import { useFormikContext } from "formik";
import TemplateProgressControls from "components/TemplateBuilderForm/TemplateProgressControls";
import PriceCalculator from "../PriceCalculator";
import ProductPricesController from "../ProductPricesController";
import Padder from "components/Padder";
import classnames from "classnames";
import Overlay from "components/Overlay";
import Button from "components/Form/fields/Button";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import Analytics, { SHOW_CALCULATOR } from "utils/analytics";

const TemplatePricesPicker = ({ tracking }) => {
  /**
   * TODO: currently the Overlay is only being shown on mobile
   * - should consolidate to consistent treatment across forms
   */
  const [showOverlay, setShowOverlay] = useState(false);
  const [showCalculator, setShowCalculator] = useState(false);
  const { values } = useFormikContext();
  const { products } = values;

  const options = products.map((product, productIx) => {
    const isFirst = !productIx;
    const isLast = productIx === products.length - 1;
    const optionProps = {
      isFirst,
      isLast,
      tracking,
      ...product
    };
    return (
      <div
        className={classnames("w-100", {
          pb4: !isLast,
          pt3: !isFirst
        })}
        key={productIx}
      >
        <ProductPricesController productIndex={productIx} {...optionProps} />
      </div>
    );
  });
  const copyContent = (
    <div className="w-100 w-70-ns">
      <div className="f3 f2-ns fw5 pt3">Set your prices</div>
      <div className="f5 f3-ns pt3 lh-copy">
        Set the prices for your chosen products.
      </div>
      <div className="f6 f4-ns pt2 lh-copy">
        Not sure what price to set? Use the calculator to help generate a price
        for you.
      </div>
    </div>
  );

  return (
    <div className="w-100 flex flex-column flex-row-ns">
      <div className="dn flex-ns flex-column w-100 w-50-ns pt3 pl3 pt3 pa3-ns pa4-ns bg-content--secondary">
        {copyContent}
        <div className="dib pt3">
          <Button
            theme="slim"
            copy={`${showCalculator ? "Hide" : "Show "} calculator`}
            onClick={() => setShowCalculator(!showCalculator)}
          />
        </div>
        {showCalculator && (
          <div className="pt3 w-80">
            <div className="pa3 bg-white ba hairline-1 br2 shadow-0">
              <PriceCalculator tracking={tracking} />
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-column w-100 w-50-ns relative">
        <div
          style={{ top: 56 }}
          className="sticky top-0 pb3 bg-white bb hairline-1 z-6"
        >
          <TemplateProgressControls />
        </div>
        <div className="flex dn-ns bg-white flex-column w-100 pa3">
          {copyContent}
          <div className="dib pt3">
            <Button
              theme="slim"
              classes={{
                contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
              }}
              copy="Show calculator"
              onClick={() => {
                Analytics.track(SHOW_CALCULATOR, tracking);
                setShowOverlay(true);
              }}
            />
          </div>
        </div>
        <ul className="ma0 pr2 pa3 list bg-white pt4-ns">{options}</ul>
        <div className="bg-white">
          <Padder theme="visible" />
        </div>
      </div>
      {showOverlay && (
        <Overlay hideOverlay={() => setShowOverlay(false)}>
          <div className="pa3">
            <PriceCalculator />
          </div>
        </Overlay>
      )}
    </div>
  );
};

export default TemplatePricesPicker;
